import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import PageWrapper from "components/page/PageWrapper";
import QEditor from "components/editor/QEditor";


import bg from 'assets/images/banner/banner01.jpg';

export default function CertificationEditor(props){
  const {t} = useTranslation();
  const params = useParams();
  const parentMenuName= t('menu.sub-certification');
  const menuName=t('menu.sub-editor');
  const path=[
    {url:'/corporation', name:t('menu.main-about')}, 
    {url:'/corporation/certifications', name:parentMenuName},
    {url:'/corporation/certifications/editor', name:menuName},
  ];
  const title = t('certifications.banner.title')
  const comment = t('certifications.banner.comment')

  const type = 'certifications';

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      <div className="flex justify-center">
        <div className="flex flex-col lg:w-[1200px]">
          <div className="mb-20">
            <QEditor postId={params.id} type={type}/>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}